import {curry} from 'ramda'

const addClass = curry((className, el) => el.classList.add(className))
const removeClass = curry((className, el) => el.classList.remove(className))
const hasClass = curry((className, el) => el.classList.contains(className))
const toggleClass = curry((className, el) => hasClass(className, el) ? removeClass(className, el) : addClass(className, el))

window.aboundOpener = (buttonEls, closedClass, animationTransitionTimeMs) => {
    if(!buttonEls || !buttonEls.length) return

    const getParentSection = el => document.getElementById(el.dataset.parentSection)

    buttonEls.forEach(el => el.addEventListener('click', ({currentTarget}) => toggleClass(closedClass, getParentSection(currentTarget))))
}



// WEBPACK FOOTER //
// ./abound-open.js